module.exports = __webpack_public_path__ + "img/10.cab8fd88.png";